import AppRecord from './AppRecord.js'

class Bank extends AppRecord {

}
export default Bank
